import { render, staticRenderFns } from "./roads-notes.vue?vue&type=template&id=a219e9e6"
import script from "./roads-notes.vue?vue&type=script&lang=js"
export * from "./roads-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports